import { UnitService } from '@application/unit.service';
import { UniversalConfig } from '@application/universal_config.service';
import { AsyncSignalValue, asyncSignalAccessible, asyncSignalIdle, asyncSignalPending } from '@cortex-shim/async_signal.component';
import { signal } from '@preact/signals-react';
import { Injectable, Scopes } from '@visiba/instantiation';
import { delay } from '@visiba/std';

@Injectable({
	scope: Scopes.Scoped,
})
export class ViewFindReceptionController {
	public presentation = signal<AsyncSignalValue<Presentation>>(asyncSignalPending());

	constructor(
		private readonly unitService: UnitService,
		private readonly universalConfig: UniversalConfig,
	) {}

	async whenMount() {
		this.presentation.value = asyncSignalAccessible({
			backgroundImageUrl: this.universalConfig.theme.BackgroundImageUrl || null,
			unitName: this.unitService.rootUnit.name,
		});
	}
}

interface Presentation {
	backgroundImageUrl: string | null;
	unitName: string;
}
